import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var TourIcon = function TourIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "10",
    height: "14",
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3.59333C9 3.12145 8.90947 2.65419 8.73358 2.21822C8.55769 1.78226 8.29988 1.38613 7.97487 1.05246C7.64987 0.718791 7.26403 0.454108 6.83939 0.273526C6.41475 0.0929443 5.95963 0 5.5 0C5.04037 0 4.58525 0.0929443 4.16061 0.273526C3.73597 0.454108 3.35013 0.718791 3.02513 1.05246C2.70012 1.38613 2.44231 1.78226 2.26642 2.21822C2.09053 2.65419 2 3.12145 2 3.59333C2 4.30533 2.205 4.96753 2.5525 5.52603H2.5485C3.7285 7.4228 5.5 10.2667 5.5 10.2667L8.4515 5.52603H8.448C8.80821 4.94924 8.99977 4.2785 9 3.59333ZM5.5 5.13333C5.10218 5.13333 4.72064 4.97108 4.43934 4.68228C4.15804 4.39347 4 4.00177 4 3.59333C4 3.1849 4.15804 2.79319 4.43934 2.50439C4.72064 2.21558 5.10218 2.05333 5.5 2.05333C5.89782 2.05333 6.27936 2.21558 6.56066 2.50439C6.84196 2.79319 7 3.1849 7 3.59333C7 4.00177 6.84196 4.39347 6.56066 4.68228C6.27936 4.97108 5.89782 5.13333 5.5 5.13333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93485 13.0669L8.18333 11.9391L2 10.8114L4.24848 9.68359",
    stroke: "currentColor"
  }));
};

export default TourIcon;